import React, { useRef, useEffect, useState } from 'react'
import { Route, Switch } from 'react-router-dom'
import Sidebar, { collapsedWidth, drawerWidth } from '../components/Sidebar/Sidebar'
import routes from '../routes'
import { Box } from '@mui/material'

// Remembered per browser: someone who likes the icon-only rail keeps it.
const COLLAPSE_KEY = 'rmf.sidebarCollapsed'
const readCollapsed = () => {
  try { return localStorage.getItem(COLLAPSE_KEY) === '1' } catch (_) { return false }
}

function Admin(props) {
  var divRef = useRef(null)
  const [collapsed, setCollapsed] = useState(readCollapsed)

  useEffect(() => {
    document.documentElement.scrollTop = 0
    document.scrollingElement.scrollTop = 0
    divRef.current.scrollTop = 0
  }, [])

  const toggleCollapsed = () => {
    setCollapsed(c => {
      const next = !c
      try { localStorage.setItem(COLLAPSE_KEY, next ? '1' : '0') } catch (_) {}
      return next
    })
  }

  const getRoutes = routes => {
    return routes.map((prop, key) => {
      if (prop.layout === '/admin') {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        )
      } else {
        return null
      }
    })
  }

  return (
    <Box sx={{ bgcolor: '#f8fafc', minHeight: '100vh' }}>
      <Sidebar collapsed={collapsed} onToggleCollapsed={toggleCollapsed} />
      <Box
        sx={{
          ml: { xs: 0, sm: `${collapsed ? collapsedWidth : drawerWidth}px` },
          transition: 'margin-left 180ms ease',
          paddingTop: { xs: 10, sm: 0 },
          minHeight: '100vh',
          bgcolor: '#f8fafc'
        }}
        ref={divRef}>
        <Switch>{getRoutes(routes)}</Switch>
      </Box>
    </Box>
  )
}

export default Admin
